// extracted by mini-css-extract-plugin
export default {"banner":"ReferralAccessBanner_banner__xI4Nl","title":"ReferralAccessBanner_title__lkEX8","message":"ReferralAccessBanner_message__oEoPP","until":"ReferralAccessBanner_until__1VmUc"};